<div class="my-login-page">
	<section class="h-100">
		<div class="container h-100">
			<div class="row h-100">
				<div class="card-wrapper">
					<div class="mt-3 mb-3 text-center" style="position: relative">
						<img src="../../../assets/images/app_logo_with_icon1.png" alt="" width="auto" height="auto">
						<br/>
						<b><label style="position: center;color: #de1627">Version {{ appVersion}}</label></b>
					</div>
					<div class="card fat">
						<div class="card-body">
							<h4 class="card-title">{{ 'LOGIN.LBL_TITLE' | translate }}</h4>
							<form>
								<div class="form-group">
									<label for="userName">{{ 'LOGIN.LBL_USER_NAME' | translate }}</label>
									<input #login_username id="login_username" type="text" class="form-control"
										name="userName" value=""  placeholder="{{'LOGIN.LBL_USER_NAME' | translate}}" 
										[(ngModel)]="loginCredential.Email" >
								</div>
								<div class="form-group">
									<label for="password">{{ 'LOGIN.LBL_PASSWORD' | translate }}
										<!-- <a class="link-primary float-right" (click)="resetPasswordEvent()">
											Reset Password
										</a> -->
									</label>
									<div style="position:relative">
										<div class="input-with-icon">
											<input #login_password id="login_password"
												[type]="showPassword ? 'text' : 'password'" class="form-control"
												name="password" required="" data-eye="" style="padding-right: 60px;"
												autocomplete="off" placeholder="{{'LOGIN.LBL_PASSWORD' | translate}}"
												[(ngModel)]="loginCredential.Password" >
											<div class="btn btn-default icon" (click)="showPassword = !showPassword">
												<i class="fa" aria-hidden="true"
													[ngClass]="{'fa-eye': !showPassword, 'fa-eye-slash': showPassword}"></i>
											</div>
											<input type="hidden" id="passeye-0">
										</div>
									</div>
								</div>
								<div class="form-group">
									<!-- <alert></alert> -->
								</div>
								<div class="form-group mt-4 mb-3">
									<button id="login_submit" type="submit" class="btn btn-primary btn-block"
										(click)="loginBtnClickEvent()">
										{{ 'LOGIN.BTN_LOGIN' | translate }}
									</button>
								</div>
								<div class="form-group mt-4 mb-4">
									<!-- <hr /> -->
								</div>
							</form>
							<!-- <div class="form-group mt-3 text-center">
								<button id="login_openlogin" class="btn btn-light btn-block custom-google-btn shadow-sm"
									(click)="doGoogleAuthentication()">
									<img src="../../../assets/images/google_logo.svg" width="8%" height="8%"
										class="mr-4" />{{
									'LOGIN.GOOGLE_SIGN_IN' | translate }}
								</button>
							</div> -->
						</div>
					</div>
					<div class="footer">
						{{ 'LOGIN.LBL_FOOTER' | translate }}
					</div>


				</div>
			</div>
		</div>
	</section>
</div>